import React from 'react';
import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';

type Props = {
  hasLine: boolean;
  noPadding?: boolean;
};

export const Spacer = ({ hasLine, noPadding = false }: Props) => {
  return (
    <Outer hasLine={hasLine} noPadding={noPadding}>
      <Line hasLine={hasLine} />
    </Outer>
  );
};

const outerPadding = (hasLine: boolean, noPadding?: boolean) => {
  if (noPadding) {
    return '0';
  }

  return hasLine ? '25px 0' : '30px 0';
};

const Outer = styled.div`
  padding: ${(props: Props) => outerPadding(props.hasLine, props.noPadding)};
  width: 100%;
`;

const LineOverrides = `
  border: 1px solid ${Colors.neutral300};
`;

const Line = styled.div<{ hasLine: boolean }>`
  border: ${({ hasLine }) => (hasLine ? `1px solid ${Colors.gray20}` : `none`)};

  ${({ hasLine }) => hasLine && LineOverrides};
`;
